<template>
    <ac-modal :title="'Self Termination Feedback'" ref="modal">
        <template>
            <div v-if="widgetReady">
                <span>{{feedback}}</span>
            </div>
        </template>
        <template slot="buttons">
            <ac-button class="btn btn-sm btn-red" :action="closeModal">Close</ac-button>
        </template>
    </ac-modal>
</template>

<script>
    export default {
        name: "SelfTerminationFeedbackModal",
        data() {
            return {
                widgetReady: false,
                feedback: ""
            };
        },
        methods: {
            async showModal(feedback) {
                this.feedback = feedback;
                this.widgetReady = true;
                this.$refs.modal.open();
            },
            async closeModal() {
                this.$refs.modal.close();
            }
        },
    }
</script>

<style scoped>
    .row {
        margin-top: 10px;
    }
</style>